import Muuri from 'muuri';

const GRID_ELEMENT = '.grid'; // Must match styled container className
const KPI_CARD = 0;
let numGridItems = 0;

// Dictionary of cards that should be static in the grid
const staticCards = {
  KPI_CARD: 'KPI_CARD',
  ADD_CHART_CARD: 'ADD_CHART_CARD',
};

const dragSortOptions = {
  action: 'move',
  threshold: 50,
};

const dragStartOptions = {
  distance: 100,
  delay: 100,
};

/**
 * Helper function for getting an ID of an item and checking to see if it
 * can be dragged.
 * @param {*} item Current grid item being checked
 */
function isDraggable(item) {
  const itemId = item.getElement().getAttribute('id');
  const staticItems = Object.keys(staticCards);
  if (staticItems.includes(itemId)) {
    return false;
  }
  return true;
}

function dragStartPredicate(item, event) {
  // Determines dragability
  if (!isDraggable(item)) {
    return false;
  }
  // For other items use the default drag start predicate.
  return Muuri.ItemDrag.defaultStartPredicate(item, event, dragStartOptions);
}

function isSortable(result, resultIndex) {
  // Any computation more intense then this line below will create grid freezing
  const lastItemIndex = numGridItems - 1;
  if (
    (result && resultIndex === KPI_CARD) ||
    (result && resultIndex === lastItemIndex)
  ) {
    return false;
  }
  return true;
}

function dragSortPredicate(item) {
  const result = Muuri.ItemDrag.defaultSortPredicate(item, dragSortOptions);
  // NOTE: result only contains an items index. Cannot use item id to identify, only index
  return isSortable(result, result.index) ? result : false;
}

/**
 * This utility func is needed b/c performing any operations in dragStart or
 * dragSort freeze the drag and drop. This way, we only caluclate length when
 * the grid changes by performing the operation in a useEffect hook.
 * @param {*} numberOfGridItems // number of items in the grid
 */
export function setNumGridItems(numberOfGridItems) {
  numGridItems = numberOfGridItems;
}

export const getGridInstance = () => {
  const grid = new Muuri(GRID_ELEMENT, {
    dragEnabled: true,
    dragStartPredicate: (item, event) => dragStartPredicate(item, event, grid),
    dragSortPredicate: (item) => dragSortPredicate(item),
  });
  return grid;
};
